import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material";

export const useStyles = (props = "") =>
  makeStyles((theme: Theme) => ({
    blackRoundIcon: {
      margin: "8px",
      width: props === "summary" ? "25px" : "40px",
      height: props === "summary" ? "25px" : "40px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    imageBoxInner: {
      position: "absolute",
      top: "0",
      width: props === "summary" ? "60%" : "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#7470708a",
      borderRadius: "5px 5px 0 0",
    },
    imageBox: {
      position: "relative",
      display: "flex",
      marginBottom: "16px",
      "& img": {
        width: "100%",
        height: "147px",
      },
    },
    uploadImageBox: {
      borderRadius: "5px 5px 0 0",
      height: "147px",
      cursor: "pointer",
      backgroundColor: theme.palette.customColor.INPUT,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
    },
    TwiterInfoBox: {
      display: "flex",
      alignItems: "center",
      width: "40%",
      background: theme.palette.customColor.INPUT,
      padding: "2px",
      position: "relative",
      overflow: "hidden",
      // XImageRenderCdn's preview wrapper (the last of the two Boxes it renders) has its own
      // fixed height + bottom margin baked in, which otherwise leaves a gap under a short/no
      // image here - pin it to fill this column edge-to-edge instead.
      "& > div:last-child": {
        position: "absolute",
        inset: 0,
        margin: "0 !important",
        width: "100% !important",
        height: "100% !important",
      },
      "& > div:last-child img": {
        width: "100% !important",
        height: "100% !important",
      },
    },
    TwiterInfoImageBox: {
      display: "flex",
      minHeight: "120px",
      borderRadius: theme.borderRadius.value,
      border: `1px solid ${theme.palette.customColor.LINE}`,
      backgroundColor: theme.palette.customColor.BGLIGHT,
      position: "relative",
    },
    imageTitle: {
      width: "60%",
      minWidth: 0,
      overflowWrap: "break-word",
      wordBreak: "break-word",
      flexDirection: "column",
      display: "flex",
      justifyContent: "center",
    },
  }));
